import { useRouter } from 'next/router';

export const useRedirectToMain = (data: boolean) => {
  const router = useRouter();
  if (typeof window !== 'undefined' && data === false) {
    router.push('/');
  }
};
